export const removeTrailingSlash = (url) => url.replace(/\/+$/, '')

/**
 * Gera um slug amigável a partir do nome de um dealer.
 * Lowercase, sem acentos, espaços substituídos por hífens, sem caracteres especiais.
 */
export const createDealerSlug = (name) => {
  if (!name) return ''
  return name
    .toLowerCase()
    .normalize('NFD')
    .replace(/[\u0300-\u036f]/g, '')
    .replace(/[^a-z0-9\s-]/g, '')
    .trim()
    .replace(/\s+/g, '-')
    .replace(/-+/g, '-')
}

/**
 * Monta a URL amigável de estoque de um dealer.
 * Padrão: /{vehicleType}/{uf}/loja.{dealer-slug}-{dealerId}
 */
export const createDealerUrl = (vehicleType, uf, dealerName, dealerId) => {
  const slug = createDealerSlug(dealerName)
  return `/${vehicleType}/${uf.toLowerCase()}/loja.${slug}-${dealerId}`
}